import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Building2 } from 'lucide-react'
import { UserProfileDropdown } from '@/features/user'
import { cn } from '@/lib/utils'

export function TopBar() {
  const { t } = useTranslation()
  const location = useLocation()

  const NAV_ITEMS = [
    { label: t('nav.home'), path: '/', icon: null },
    { label: t('nav.companies'), path: '/companies', icon: Building2 },
    { label: t('nav.reports'), path: '/reports/search', icon: null },
    { label: t('nav.settings'), path: '/templates', icon: null },
  ]

  return (
    <header className="flex w-full shrink-0 items-center gap-4 bg-[#0c2d6b] px-4 py-2.5 text-white sm:px-6">
      {/* Logo */}
      <Link
        to="/"
        className="text-lg font-extrabold tracking-tight"
        aria-label={`GoAudit ${t('nav.home')}`}
      >
        Go<span className="text-[#60a5fa]">Audit</span>
      </Link>

      {/* Divider */}
      <div className="h-5 w-px bg-white/20" aria-hidden="true" />

      {/* Navigation - Hidden on mobile */}
      <nav className="hidden gap-1 md:flex" aria-label="Main navigation">
        {NAV_ITEMS.map((item) => {
          const active = location.pathname === item.path
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'rounded px-3.5 py-1.5 text-xs transition-colors focus:ring-2 focus:ring-white/30 focus:outline-none',
                active
                  ? 'bg-white/10 font-bold text-white'
                  : 'font-normal text-white/60 hover:bg-white/5 hover:text-white'
              )}
              aria-current={active ? 'page' : undefined}
            >
              {item.icon ? (
                <span className="inline-flex items-center gap-1">
                  <item.icon className="h-3 w-3" aria-hidden="true" />
                  {item.label}
                </span>
              ) : (
                item.label
              )}
            </Link>
          )
        })}
      </nav>

      {/* Spacer */}
      <div className="flex-1" />

      {/* User Profile Dropdown - Contains Language & Theme settings */}
      <UserProfileDropdown />
    </header>
  )
}
